import { createFileRoute, useNavigate } from '@tanstack/react-router'
import type { CollectionFilters } from '@/features/collections/api'
import { CollectionsView } from '@/features/collections/collections'

export const Route = createFileRoute('/_authenticated/collections')({
  validateSearch: (search: Record<string, unknown>): CollectionFilters => ({
    search: typeof search.search === 'string' ? search.search : undefined,
  }),
  component: CollectionsRoute,
})

function CollectionsRoute() {
  const params = Route.useSearch()
  const navigate = useNavigate()
  return (
    <CollectionsView
      params={params}
      onParamsChange={(next) => void navigate({ to: '/collections', search: next, replace: true })}
    />
  )
}
